import { schema } from 'normalizr';

export const PRODUCT_TOUR_STATE = 'product_tour';

export const productTourStateSchema = new schema.Entity(PRODUCT_TOUR_STATE, {}, { idAttribute: () => 'data' });
